import { Time } from '@angular/common';
import { PickupType } from '../models/pickup-type';
import { Address } from '../models/address';
import { LiveRouteType } from './live-route-type';
import { LiveRouteStatus } from './live-route-status';

export class Stops {
  StopsList: Stop[];
  TotalScannedCount: number;
  TotalCount: number;
  Route_ID: number;
  RouteStatus: number;
  StopCount: number;
  StopScannedCount: number;
  Route_Driver_Name: string;
  RoutePolylines: string;
  RoutePolylinesHere?: string;
  HasBeenLocked: Boolean;
  TotalWeight: number;
  TotalKm: number;
}

export class Stop {
  Lr_Account_ID: string;
  Route_ID: number;
  No_Stop: number;
  LiveRouteID: number;
  Shipping_ID: number;
  Consol_ID: number;
  Min_Live_Route_Status: number;
  Max_Live_Route_Status: number;
  Lr_Name: string;
  Lr_Phone: string;
  ETA: string;
  Forecasted_Arrival_Time: string;
  Arrival_Time: string;
  CustomerID: number;
  CustomerName: string;
  EXP_DATE: string;
  Type: LiveRouteType;
  Status: LiveRouteStatus;
  Address: Address;
  Note: string;
  Priority: any;
  COD: boolean;
  CODAmount: number;
  CODType: string;
  AAF: boolean;
  Reference: string;
  SNR: boolean;
  PartialDeliveryAllowed: boolean;
  ParcelCompress: Parcel[];
  PickupType: PickupType;
  ShippingType: number;
  
  IsSelected: boolean;
  NeedAddressCheck: boolean;
  IsUnserved: boolean;
  TotalCODAmount: number;
  TotalFrozen_Protection: number;
  TotalService_10H30: number;
  TotalDangerous: number;
  MaxCOD_TYPE: number;
  TotalScanned: number;
  TotalParcel: number;
  TotalPickup: number;
  isChecked: boolean;
  isClicked: boolean;

  PuNoCharge: boolean;
  NO_PICKUP_LABEL_PRINTING_TPSLROUTE: boolean;

  DeliveryMandatoryGreen: boolean;
  DeliveryGreen: boolean;
}

export class Parcel {
  Parcel_ID: number;
  No_Stop: number;
  Live_Route_Status: number;
  CODAmount: number;
  CODType: string;
  Service_10H30: boolean;
  Frozen_Protection: boolean;
  Dangerous: boolean;
  Live_Route_Type: number;
  IsSelected: boolean;
}

export class SectorCompress {
  Sector_ID: number;
  RouteCompress: RouteCompress[];
  AddPickupTpslroute : boolean;
}
export class RouteCompress {
  Route_ID: number;
  TotalScannedCount: number;
  TotalCount: number;
  TotalCountFailed: number;
  LiveRouteStatus: number;
  StopCount: number;
  StopScannedCount: number;
  Route_Driver_Name: string;
  ETA: string;
  DropOffPointID: number;
  TotalWeight: number;
  IsGreen: boolean;
  TotalKm: number;
  GeoTabUserId : string;
}

export class TpslRouteStops {
  RouteStops: Stops;
  OnHoldStops: Stops;
}
